import {Box, Lead, Slot, Text, Trail, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {type ReactElement, type ReactNode, memo} from 'react'
import {useFormContext} from 'react-hook-form'

import type {PickupPoint} from '../types'
import {createNames, renderPointSlotName} from '../utils'
import * as classes from './PointSlot.classes'

type Props = {
  name: string
  lead: ReactNode
  text: ReactNode
  trail: ReactNode
  onPress?: VoidFunction
  isDestination: boolean
}

export const PointSlot = memo<Props>(function PointSlot(props: Props): ReactElement {
  const i18n = useI18n()
  const {onPress, name, lead, text, isDestination, trail} = props
  const pickupPoint: PickupPoint | undefined = useFormContext().watch(createNames(name).pickupPoint)

  return (
    <Slot className={classes.slot} onClick={onPress} py="xs" size="l">
      <Lead>
        <Box alignItems="center" className={classes.leadBox} justifyContent="center">
          {lead}
        </Box>
      </Lead>
      <Text>
        {pickupPoint ? (
          renderPointSlotName(
            pickupPoint,
            isDestination
              ? i18n('bdui.pickup_points.point-slot.name.receive', 'Доставить в пункт')
              : i18n('bdui.pickup_points.point-slot.name.send', 'Отправить из пункта'),
          )
        ) : (
          <Typography color="minor" variant="body2">
            {text}
          </Typography>
        )}
      </Text>
      {<Trail>{trail}</Trail>}
    </Slot>
  )
})
